import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { useRoomRatesEditor } from 'components/RoomRatesEditor';
import { RoomRatesTableRateCellValue_roomRate$key } from '__generated__/RoomRatesTableRateCellValue_roomRate.graphql';

type Props = {
  roomRate: RoomRatesTableRateCellValue_roomRate$key;
};

const RoomRatesTableRateCellValue: FC<Props> = ({ roomRate }) => {
  const { viewMode } = useRoomRatesEditor();

  const { roomPriceAdult, tripPriceAdult } = useFragment(
    graphql`
      fragment RoomRatesTableRateCellValue_roomRate on RoomRate {
        roomPriceAdult
        tripPriceAdult
      }
    `,
    roomRate
  );

  return (
    <>
      {viewMode === 'accommodation'
        ? `€${roomPriceAdult}`
        : `€${tripPriceAdult}`}
    </>
  );
};

export default RoomRatesTableRateCellValue;
